export default "__VITE_ASSET__DPHvXzDS__"